import React from "react";
import "./Text.css";

type TextElement = "h1" | "h2" | "h3" | "h4" | "h5" | "p" | "span";

// Names that match the DesignKit:
// https://www.figma.com/design/iNKuKHCQa0NN2pS45bavws/Design-Kit?node-id=2197-6583&m=dev
// The comments above a name indicate the legacy name used.
type TextVariant =
  | "fontHeadingXxlarge"
  | "fontHeadingXlarge"
  | "fontHeadingLarge"
  // Large/Bold
  | "fontHeadingMedium"
  // Regular/Bold
  | "fontHeadingSmall"
  // Small/Bold
  | "fontHeadingXsmall"
  // Tiny/Bold
  | "fontHeadingXxsmall"
  // Large/Regular
  | "fontBodyLarge"
  // Regular/Regular
  | "fontBodyMedium"
  // Small/Regular
  | "fontBodySmall"
  // Label/sm
  | "labelSmall"
  // Label/md
  | "labelMedium";

const componentMap = new Map<TextVariant, TextElement>([
  ["fontHeadingXxlarge", "h1"],
  ["fontHeadingXlarge", "h1"],
  ["fontHeadingLarge", "h2"],
  ["fontHeadingMedium", "h3"],
  ["fontHeadingSmall", "h4"],
  ["fontHeadingXsmall", "h5"],
  ["fontHeadingXxsmall", "h5"],
  ["fontBodyLarge", "p"],
  ["fontBodyMedium", "p"],
  ["fontBodySmall", "p"],
]);

interface TextProps {
  variant: TextVariant;
  children: React.ReactNode;
  color?: string;
  style?: React.CSSProperties;
  className?: string;
}

const Text = ({ variant, children, color, style, className }: TextProps) => {
  const Component = componentMap.get(variant) ?? "p";
  return (
    <Component
      className={`${variant} ${className ?? ""}`}
      style={{ color, ...style }}>
      {children}
    </Component>
  );
};

export { Text };
